export default __webpack_public_path__ + "static/media/object--catch-basin.6c8a4f84.png";